// Copyright (C) 2022 TANNER AG

import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const MenuIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M15 11.5V13.25H1V11.5H15ZM15 7.125V8.875H1V7.125H15ZM15 2.75V4.5H1V2.75H15Z" fill="currentColor" />
        </SvgIcon>
    );
};

export const LogoutIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M1 1H11.5V3.33333H9.94445V2.55556H2.55556V13.4444H9.94445V12.6667H11.5V15H1V1ZM4.88889 8.76102V7.28239H12.3979L10.7983 5.50029L11.8623 4.5L15 8L11.8623 11.5L10.7983 10.4997L12.3589 8.76102H4.88889Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CloseIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.73628 8.00178L14.9999 13.2654L13.2654 14.9999L8.00211 9.73661L2.73452 15L1.00062 13.2647L6.26751 8.00202L1 2.7345L2.7345 1L8.00169 6.26718L13.2648 1.00057L14.9999 2.73458L9.73628 8.00178Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ArrowRightIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M1 6.78239H10.6588L8.09371 4.00049L9.84258 2.40002L15 8.00002L9.84258 13.6L8.09371 11.9996L10.7229 9.1482H1V6.78239Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ArrowLeftIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M14.9999 9.21761L5.34106 9.21761L7.90617 11.9995L6.1573 13.6L0.999878 7.99998L6.1573 2.39997L7.90617 4.00044L5.27702 6.8518L14.9999 6.8518V9.21761Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ArrowDownIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M6.78239 1V10.6588L4.00049 8.09371L2.40002 9.84258L8.00002 15L13.6 9.84258L11.9996 8.09371L9.1482 10.7229V1H6.78239Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const DownloadIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M15 12.3812V14.3H1V12.3812H15ZM8.85547 1.7V7.50784L10.5342 5.96544L11.5 7.01703L8.12069 10.1182L4.74138 7.01703L5.70718 5.96544L7.42782 7.54634V1.7H8.85547Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CloudDownloadIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M13.3328 7.8632C13.3667 7.69151 13.384 7.51981 13.384 7.34811C13.384 5.68277 12.0404 4.34339 10.4071 4.34339C9.93066 4.34339 9.47151 4.46345 9.06352 4.66934C8.38309 3.91415 7.41362 3.45001 6.3418 3.45001C4.31787 3.45001 2.66715 5.11535 2.66715 7.15904C2.66715 7.39914 2.68442 7.62248 2.73492 7.84583C1.73156 8.12082 1 9.04771 1 10.1462C1 11.4682 2.07181 12.55 3.3815 12.55H12.6185C13.9282 12.55 15 11.4682 15 10.1462C14.9661 9.08185 14.2857 8.1724 13.3328 7.86317L13.3328 7.8632ZM7.41667 6.43957H8.58023V7.29316H7.41667V6.43957ZM7.41667 5.80517H8.58023V6.17981H7.41667V5.80517ZM7.41195 9.72347V7.70039H8.57551V9.72347L9.54509 8.88055L10.3208 9.72347L7.99367 11.7465L5.66667 9.72347L6.44225 8.88055L7.41195 9.72347Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const PDFIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.46998 1V4.5H12.9V15H3.09998V1H9.46998ZM8.71613 1.77778H3.85382V14.2222H12.1461V5.27778H8.71613V1.77778ZM7.52903 5.43333C7.95979 5.43333 8.31396 5.79594 8.31396 6.23704C8.31396 6.74658 8.07079 7.4037 7.86258 8.06048C8.1539 8.62339 8.55959 9.15333 9.00085 9.57747C9.5455 9.38973 10.2575 9.21078 10.7475 9.21078C11.1784 9.21078 11.5325 9.57338 11.5325 10.0145C11.5325 10.4556 11.1784 10.8182 10.7475 10.8182C10.1364 10.8182 9.394 10.5385 8.88067 10.1149C8.17753 10.286 7.44891 10.5708 6.75374 10.8508L6.60023 11.1448C6.34063 11.6372 6.06566 12.128 5.82648 12.4205L5.81176 12.4331C5.66518 12.5863 5.46249 12.6667 5.25244 12.6667C4.82159 12.6667 4.46742 12.3041 4.46742 11.863C4.46742 11.6454 4.55052 11.442 4.69311 11.2928C4.69832 11.2859 4.70415 11.279 4.71028 11.2727C5.10036 10.9509 5.74921 10.7337 6.47657 10.4414C6.83201 9.73156 7.10984 8.89054 7.35485 8.10567L7.26999 7.93029C6.98984 7.34319 6.74401 6.73538 6.74401 6.23706C6.74401 5.79597 7.09819 5.43333 7.52903 5.43333ZM6.06197 11.1321L5.83961 11.2243C5.47911 11.376 5.17541 11.5177 5.02182 11.6394C4.97368 11.6937 4.93842 11.7782 4.93842 11.8629C4.93842 12.0434 5.0761 12.1844 5.25242 12.1844C5.34626 12.1844 5.41587 12.1527 5.4683 12.1015C5.62193 11.9119 5.84119 11.5355 6.06197 11.1321ZM10.7476 9.69298C10.4538 9.69298 9.95063 9.81071 9.48912 9.94414C9.89113 10.1724 10.3937 10.3359 10.7476 10.3359C10.9239 10.3359 11.0616 10.195 11.0616 10.0145C11.0616 9.83395 10.9239 9.69298 10.7476 9.69298ZM7.66396 8.66577C7.49956 9.17757 7.3263 9.69712 7.1095 10.1979C7.55814 10.023 8.01292 9.85598 8.47841 9.7257C8.17667 9.40794 7.90008 9.05036 7.66396 8.66577ZM7.52903 5.91558C7.35271 5.91558 7.21502 6.05655 7.21502 6.23706C7.21502 6.46322 7.34341 6.84366 7.51035 7.25405L7.5706 7.39963L7.5949 7.32069C7.73062 6.87367 7.84304 6.46478 7.84304 6.23706C7.84304 6.05655 7.70535 5.91558 7.52903 5.91558ZM10.393 1L12.9 3.56667H10.393V1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const DeleteIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M7.41004 4.73333H6.13324L6.25643 12.6667H7.53324L7.41004 4.73333ZM10.9142 13.4617C10.9136 13.53 10.8764 13.5669 10.8306 13.5669H5.16985C5.1235 13.5669 5.08574 13.53 5.08574 13.4846L4.79853 4.73333H3.33324L3.75569 15C3.71293 14.9867 5.17039 15 5.17039 15H12.2441L12.6666 4.73333H11.2013L10.9142 13.4617ZM9.86657 4.73333L9.74338 12.6667H8.46657L8.58976 4.73333H9.86657ZM11.0062 1V2.41474H13.5999V3.82947H2.3999V2.41474H5.05253V1H11.0062ZM10.0631 1.58947H5.93674V2.17895H10.0631V1.58947Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const EditOutlinedIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="m14.06 9.02.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const OpenIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M6.06591 1V2.56094H2.55704V13.4457L13.4525 13.4476V9.95491L15 9.95304V15H1V1H6.06591ZM14.9994 1V5.66667H13.4438V3.66359L9.11939 8L8.01945 6.90006L12.352 2.55556H10.3327V1H14.9994Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const LinkExternIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M15 1V6.44445H13.1821V4.10753L11.0104 6.2815L11.0106 15H1V5.00613L9.71733 5.00604L11.9062 2.81482H9.54644V1H15Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ChatIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M10.625 2.3125L10.625 4.06235L15 4.0625V10.7708H13.8333V13.6875L10.9167 10.7708H6.54167L6.54152 9.3123L5.66667 9.3125L2.45833 12.5208V9.3125H1V2.3125H10.625ZM13.8333 5.22916H7.70833V9.60417H11.5L12.7542 10.9167L12.6667 9.60417H13.8333V5.22916ZM9.45148 6.97409V7.84909H8.57648V6.97409H9.45148ZM11.2015 6.97409V7.84909H10.3265V6.97409H11.2015ZM12.9515 6.97409V7.84909H12.0765V6.97409H12.9515ZM3.91667 5.52083H3.04167V6.39583H3.91667V5.52083ZM5.66667 5.52083H4.79167V6.39583H5.66667V5.52083Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ChartIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 1V8H15C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.17267 4.07164 1.06275 7.88424 1.00094L8 1ZM8.77771 1.77777C11.6314 2.05277 13.9082 4.32484 14.2222 7.19432L8.77778 7.19415L8.77771 1.77777Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ChartOutlineIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M1.77778 8C1.77778 11.4364 4.56356 14.2222 8 14.2222C11.173 14.2222 13.7913 11.8471 14.1741 8.77778H7.22222V1.82592C4.15287 2.20866 1.77778 4.82696 1.77778 8ZM8 1V8H15C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM9.55556 6.41648H13.2826C12.7768 4.607 11.3525 3.18931 9.55556 2.70637V6.41648ZM14.2222 7.19426H8.77778V1.77778C11.6314 2.05281 13.9081 4.32483 14.2222 7.19426Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const AddCircleIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8.61314 3.6634L7.38663 3.66381L7.38788 7.38672H3.66352V8.61323H7.38812L7.38663 12.3361L8.61314 12.3366L8.61463 8.61323H12.3363V7.38672H8.61439L8.61314 3.6634Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const MinusCircleIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM12.3363 7.38672H3.66352V8.61323H12.3363V7.38672Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CheckCircleIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM10.9432 5.1013L7.20205 9.25835L4.89637 7.35294L4.1311 8.27036L7.32453 10.9094L11.8355 5.8969L10.9432 5.1013Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const HelpCircleIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 1.77778C4.56356 1.77778 1.77778 4.56356 1.77778 8C1.77778 11.4364 4.56356 14.2222 8 14.2222C11.4364 14.2222 14.2222 11.4364 14.2222 8C14.2222 4.56356 11.4364 1.77778 8 1.77778ZM8.52748 10.6624V11.8889H7.21361V10.6624H8.52748ZM7.97671 4.11111C8.71848 4.11111 9.2959 4.2989 9.7111 4.67447C10.1263 5.05004 10.3333 5.57097 10.3333 6.23829C10.3333 6.68388 10.2031 7.09766 9.94376 7.47853C9.6844 7.8594 9.35675 8.2074 8.96075 8.52357C8.7601 8.69862 8.63309 8.86625 8.58186 9.02435C8.53063 9.18245 8.50502 9.41371 8.50502 9.71926H7.22001C7.22321 9.21742 7.28191 8.85883 7.39504 8.64242C7.50818 8.42598 7.75899 8.15543 8.1475 7.82867C8.42286 7.56238 8.64166 7.30668 8.80388 7.06268C8.9661 6.81867 9.04723 6.54919 9.04723 6.25423C9.04723 5.91367 8.95437 5.64948 8.76867 5.4617C8.58296 5.27391 8.31934 5.18053 7.97673 5.18053C7.68429 5.18053 7.43453 5.26011 7.22961 5.42031C7.02468 5.58051 6.92222 5.81603 6.92222 6.12796H5.68306L5.66705 6.09614C5.65638 5.47124 5.8677 4.98425 6.29997 4.63522C6.73222 4.28616 7.2915 4.11111 7.97671 4.11111Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const DataIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8.00048 1.70001L15 5.50195L13.3798 6.38346L8.00111 9.30397L1.00158 5.50203L8.00048 1.70001ZM7.99955 10.2841C7.99955 10.2841 9.91523 9.29569 13.7466 7.31887L14.9991 8.00004L13.4153 8.86038C13.4029 8.87011 13.3905 8.87298 13.3789 8.87985L12.491 9.36297L7.99953 11.8021L1 7.9984L2.2502 7.31895L7.99955 10.2841ZM2.25183 9.81515C6.08376 11.8283 7.99972 12.8349 7.99972 12.8349C7.99972 12.8349 9.91539 11.8289 13.7467 9.81691L14.9992 10.4981L7.99972 14.3L1.0002 10.4963L2.25183 9.81515Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ChevronDownIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M12.9994 3.33337L15 5.69473L8 12.6667L1 5.69473L3.00059 3.33337L8 8.31278L12.9994 3.33337Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ChevronUpIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M12.6667 12.9994L15 10.9994L8 4.00059L1 10.9994L3.33331 12.9994L8 8.31271L12.6667 12.9994Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ChevronRightIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M3.33331 3.00059L5.69467 1L12.6666 8L5.69467 15L3.33331 12.9994L8.31271 8L3.33331 3.00059Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ChevronLeftIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M12.6667 12.9994L10.3053 15L3.33337 8L10.3053 1L12.6667 3.00059L7.68729 8L12.6667 12.9994Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const UserIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M12.9174 11.813C13.7353 10.7597 14.2222 9.43674 14.2222 8C14.2222 4.56356 11.4364 1.77778 8 1.77778C4.56356 1.77778 1.77778 4.56356 1.77778 8C1.77778 9.43674 2.26473 10.7597 3.08259 11.813L3.36598 9.65273L5.47209 8.81019L7.99974 9.65273L10.5279 8.81019L12.634 9.65273L12.9174 11.813ZM5.90004 5.90043C5.8119 4.51431 6.6222 3.33333 7.99979 3.33333C9.37739 3.33333 10.1877 4.51431 10.1 5.90043C10.0207 7.15272 9.49669 8.38889 7.99979 8.38889C6.50289 8.38889 5.97893 7.15272 5.90004 5.90043ZM8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const User2Icon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M11.5002 8.58333L14.4163 9.74993L15 15H1L1.58367 9.74993L4.49982 8.58333L7.99963 9.74993L11.5002 8.58333ZM7.99971 1C9.90715 1 11.0291 2.6352 10.9077 4.55444C10.7978 6.28838 10.0723 8 7.99971 8C5.92708 8 5.2016 6.28838 5.09237 4.55444C4.97033 2.6352 6.09227 1 7.99971 1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const WorldIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM7.00476 2.08379C5.1837 2.38606 3.6409 3.49914 2.76705 5.04963H4.94604C5.39801 3.96415 6.08883 2.94935 7.00476 2.08379ZM8.98993 2.08379H8.99008C9.90716 2.94874 10.5962 3.96486 11.0488 5.04963H13.2331C12.3586 3.49914 10.814 2.38594 8.98993 2.08379ZM2.44752 5.7203L2.44764 5.71969C2.15918 6.42343 1.99749 7.19012 1.99749 7.99939C1.99749 8.78023 2.14616 9.52732 2.41624 10.211H4.62606C4.41104 9.46631 4.31095 8.70498 4.32753 7.94191C4.34411 7.19194 4.46968 6.44426 4.69949 5.7203H2.44752ZM11.2947 5.7203L11.2947 5.72091C11.5252 6.44481 11.6556 7.19248 11.6721 7.94252C11.6887 8.7056 11.5886 9.46689 11.3735 10.2116H13.5839C13.8541 9.52728 14.0028 8.78084 14.0028 8C14.0028 7.19016 13.841 6.42412 13.5525 5.7203H11.2947ZM4.85762 10.8817H2.73065C3.59333 12.4582 5.13957 13.6004 6.97382 13.9156C5.9886 13.0221 5.29011 11.983 4.85762 10.8817ZM11.143 10.8817H11.1434C10.7098 11.9837 10.0089 13.0222 9.02193 13.9156C10.8586 13.601 12.4072 12.4582 13.2698 10.8817H11.143ZM8.06513 5.05117H10.2773C9.83654 4.12495 8.85859 2.82907 8.0026 2.09511C7.15008 2.82783 6.16169 4.12713 5.72267 5.0516H8.06514L8.06513 5.05117ZM8.0838 10.9124L8.08381 10.912H5.74133C6.18036 11.8491 7.16875 13.1662 8.02127 13.9089C8.87725 13.1649 9.85521 11.8513 10.296 10.9124H8.0838ZM7.93467 5.7203V5.71815L5.47304 5.718C5.23805 6.44497 5.10958 7.19619 5.0942 7.95038C5.07883 8.70996 5.17875 9.47243 5.39507 10.2089H7.92558V10.2111H10.5956C10.8227 9.47466 10.9267 8.7122 10.9106 7.95268C10.8951 7.19846 10.7554 6.44724 10.5093 5.7203H7.93467Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const InfoCircleIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8.28 3.52C8.91 3.52 9.435 4.045 9.435 4.675C9.435 5.305 8.91 5.83 8.28 5.83C7.65 5.83 7.125 5.305 7.125 4.675C7.125 4.045 7.65 3.52 8.28 3.52ZM8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 1.77778C4.56356 1.77778 1.77778 4.56356 1.77778 8C1.77778 11.4364 4.56356 14.2222 8 14.2222C11.4364 14.2222 14.2222 11.4364 14.2222 8C14.2222 4.56356 11.4364 1.77778 8 1.77778ZM9.225 6.775V10.975H10.17V11.92H6.425V10.975H7.37V7.72H6.425V6.775H9.225Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const BusIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M13.3529 3.49311V2.67368L12.5294 1.85425H3.47059L2.64706 2.67368V3.49311H1V6.77084H2.23529V3.90283H2.64706V12.9166L3.05882 13.3263H3.47059V14.1457H5.11765V13.3263H10.8824V14.1457H12.5294V13.3263H12.9412L13.3529 12.9166V3.90283H13.7647V6.77084H15V3.49311H13.3529ZM3.05882 12.5069V11.6874H4.29412L4.70588 12.5069H3.05882ZM9.64706 12.5069H6.35294L5.94118 11.6874H10.0588L9.64706 12.5069ZM3.88235 10.4583L3.47059 9.63885V3.90283H12.5294V9.63885L12.1176 10.4583H3.88235ZM12.9412 12.5069H11.2941L11.7059 11.6874H12.9412V12.5069Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CalendarIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M13.95 15V2.86667H2.04999V15H13.95ZM13.0262 6.6V14.0667H2.95699V6.6H13.0262ZM6.16083 10.8H4.33006V12.6667H6.16083V10.8ZM8.91537 10.8H7.0846V12.6667H8.91537V10.8ZM6.16083 8H4.33006V9.86667H6.16083V8ZM8.91537 8H7.0846V9.86667H8.91537V8ZM11.6615 8H9.83076V9.86667H11.6615V8ZM5.0166 1V2.86667H4.10122V1H5.0166ZM11.882 1V2.86667H10.9666V1H11.882Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CheckIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M13.3785 2.75L15 4.18831L6.8029 13.25L1 8.47909L2.3906 6.82055L6.58034 10.2652L13.3785 2.75Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ShareIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M12.83 10.6491C12.095 10.6491 11.43 11 11.045 11.5614L5.27 8.68421C5.34 8.47369 5.375 8.22807 5.375 8.01754C5.375 7.80702 5.34 7.5614 5.27 7.35088L11.045 4.47368C11.43 5.03509 12.095 5.38597 12.83 5.38597C14.055 5.38597 15 4.40351 15 3.21053C15 2.01754 14.02 1 12.83 1C11.64 1 10.66 1.98246 10.66 3.17544C10.66 3.2807 10.66 3.35088 10.695 3.45614L4.745 6.4386C4.36 6.05263 3.8 5.80702 3.205 5.80702C1.98 5.84211 1 6.78947 1 8.01754C1 9.24562 1.98 10.193 3.17 10.193C3.765 10.193 4.29 9.94737 4.71 9.5614L10.66 12.5439C10.66 12.6491 10.625 12.7193 10.625 12.8246C10.625 14.0526 11.605 15 12.795 15C13.985 15 14.965 14.0175 14.965 12.8246C14.965 11.6316 14.02 10.6491 12.83 10.6491Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const NewTabIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M6.06591 1V2.56094H2.55704V13.4457L13.4525 13.4476V9.95491L15 9.95304V15H1V1H6.06591ZM14.9994 1V5.66667H13.4438V3.66359L9.11939 8L8.01945 6.90006L12.352 2.55556H10.3327V1H14.9994Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const DotsHorizontalIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M4.5 8C4.5 8.9625 3.7125 9.75 2.75 9.75C1.7875 9.75 1 8.9625 1 8C1 7.0375 1.7875 6.25 2.75 6.25C3.69363 6.25 4.46905 7.00692 4.4991 7.94359L4.5 8ZM6.25 8C6.25 7.0375 7.0375 6.25 8 6.25C8.9625 6.25 9.75 7.0375 9.75 8C9.75 8.9625 8.9625 9.75 8 9.75C7.05637 9.75 6.28095 8.99308 6.2509 8.05641L6.25 8ZM11.5 8C11.5 7.0375 12.2875 6.25 13.25 6.25C14.2125 6.25 15 7.0375 15 8C15 8.9625 14.2125 9.75 13.25 9.75C12.3064 9.75 11.5309 8.99308 11.5009 8.05641L11.5 8Z"
                fill="currenColor"
            />
        </SvgIcon>
    );
};

export const UploadFileIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.47001 1V4.5H12.9V15H3.10001V1H9.47001ZM7.9846 6.83333L6.0628 8.73364L6.61204 9.37803L7.56673 8.43289V12.9583H8.37863V8.40929L9.35715 9.37803L9.9064 8.73364L7.9846 6.83333ZM10.393 1L12.9 3.56667H10.393V1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CalculatorIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M13.25 1H2.75C2.75 1.14769 2.75 13.7076 2.75 15H13.25V1ZM6.404 13.8471H3.968V11.5H6.404V13.8471ZM6.404 11.1294H3.968V8.78235H6.404V11.1294ZM9.218 13.8471H6.782V11.5H9.218V13.8471ZM9.218 11.1294H6.782V8.78235H9.218V11.1294ZM9.218 8.37059H6.782V6.02353H9.218V8.37059ZM12.032 13.8471H9.596V11.5H12.032V13.8471ZM12.032 11.1294H9.596V8.78235H12.032V11.1294ZM12.032 8.37059H9.596V6.02353H12.032V8.37059ZM12.032 4.87059H3.968V2.52353H12.032V4.87059Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ShowIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 2.75C11.5556 2.86667 13.8889 4.61667 15 8C13.7778 11.2667 11.5556 13.0167 8.33333 13.25C4.77778 13.25 2.33333 11.5 1 8C2.33333 4.5 4.66667 2.75 8 2.75ZM8 5.17308C6.40812 5.17308 5.11765 6.43873 5.11765 8C5.11765 9.56127 6.40812 10.8269 8 10.8269C9.59188 10.8269 10.8824 9.56127 10.8824 8C10.8824 6.43873 9.59188 5.17308 8 5.17308Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const HideIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M1.85352 1L4.53968 3.7429C5.57951 3.1983 6.76042 2.89308 8 2.89308C11.1752 2.89308 13.9772 4.87863 14.9727 7.83432C15.0091 7.94137 15.0091 8.0584 14.9727 8.16613C14.4946 9.58529 13.5962 10.7766 12.4423 11.6354L12.3398 11.7103L14.8535 14.2779L14.1465 15L1.14649 1.72215L1.85352 1ZM2.9304 4.95874L5.08139 7.15571C5.09637 7.17101 5.10222 7.19295 5.09702 7.21356C4.53907 9.4325 6.57098 11.5006 8.73501 10.9387C8.75975 10.932 8.78253 10.9367 8.80076 10.9553L10.3606 12.5486C10.4088 12.5978 10.3893 12.6836 10.3242 12.7048C6.4745 13.9643 2.30851 11.9375 1.02734 8.13793C0.990885 8.03021 0.990885 7.91119 1.02734 7.80347C1.39844 6.70163 2.02214 5.73672 2.82167 4.95741C2.85227 4.92815 2.90045 4.92882 2.9304 4.95874ZM8.00004 4.93569C7.38372 4.93569 6.81229 5.12813 6.33522 5.45492L6.26438 5.50494L10.4427 9.77258C10.7923 9.27122 11 8.66078 11 7.99981C11 6.33464 9.69302 4.9756 8.07173 4.93656L8.00004 4.93569Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const SearchIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M15 13.495L10.835 9.365C11.395 8.525 11.745 7.475 11.745 6.39C11.745 3.415 9.33 1 6.39 1C3.415 1 1 3.415 1 6.39C1 9.365 3.415 11.745 6.355 11.745C7.475 11.745 8.49 11.395 9.33 10.835L13.495 15L15 13.495ZM2.05 6.39C2.05 4.01 4.01 2.05 6.39 2.05C8.77 2.05 10.695 3.975 10.695 6.355C10.695 8.735 8.77 10.66 6.39 10.66C4.01 10.695 2.05 8.77 2.05 6.39Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const EditIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M1.84733 12.027L3.96722 14.151L1 15L1.84733 12.027ZM10.8857 2.9901L12.9841 5.09253L4.59113 13.5019L2.49279 11.3994L10.8857 2.9901ZM12.9017 1L15 3.10244L13.5915 4.51369L11.4932 2.41125L12.9017 1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const PlayIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M2.75 15V1L13.25 8L2.75 15Z" fill="currentColor" />
        </SvgIcon>
    );
};

export const FilterIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.18748 7.89967L14.65 1H1.34998L6.81248 7.89967V15L9.18748 14.0667V7.89967Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const FileUploadIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.47001 1V4.5H12.9V15H3.10001V1H9.47001ZM7.9846 6.83333L6.0628 8.73364L6.61204 9.37803L7.56673 8.43289V12.9583H8.37863V8.40929L9.35715 9.37803L9.9064 8.73364L7.9846 6.83333ZM10.393 1L12.9 3.56667H10.393V1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const FileUploadOutlineIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.47 1V4.5H12.9V15H3.1V1H9.47ZM8.71615 1.77778H3.85384V14.2222H12.1462V5.27778H8.71615V1.77778ZM7.98459 6.83333L9.90639 8.73364L9.35714 9.37803L8.37862 8.40929V12.9583H7.56672V8.43289L6.61204 9.37803L6.06279 8.73364L7.98459 6.83333ZM10.393 1L12.9 3.56667H10.393V1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CSVIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.46998 1V4.5H12.9V15H3.09998V1H9.46998ZM8.71613 1.77778H3.85382V14.2222H12.1461V5.27778H8.71613V1.77778ZM5.96907 10.5667C6.18162 10.5667 6.3452 10.6065 6.45982 10.6863C6.56443 10.7592 6.6376 10.8524 6.67933 10.9657C6.71642 11.0665 6.73659 11.2044 6.73983 11.3794L6.74026 11.4468H6.26118V11.4024L6.25996 11.3476C6.25601 11.2417 6.24306 11.158 6.22112 11.0965C6.17995 10.9814 6.09815 10.9238 5.97574 10.9238C5.85111 10.9238 5.76681 10.9888 5.72285 11.1187C5.68183 11.2399 5.65995 11.4638 5.65721 11.7905L5.65692 11.8621C5.65692 12.1503 5.66972 12.3696 5.69531 12.52C5.7287 12.7126 5.82217 12.8089 5.97574 12.8089C6.0848 12.8089 6.16242 12.7604 6.2086 12.6636C6.25059 12.5756 6.27395 12.4329 6.27868 12.2356L6.27955 12.1748H6.76029V12.2278L6.7589 12.2987C6.75159 12.5068 6.71589 12.6728 6.65179 12.7969C6.58613 12.9268 6.49989 13.0208 6.39305 13.0789C6.28511 13.137 6.13989 13.166 5.95738 13.166C5.72035 13.166 5.53952 13.1051 5.41488 12.9832C5.31472 12.8852 5.24573 12.7564 5.20789 12.5969C5.17321 12.4507 5.15442 12.2365 5.15153 11.9544L5.15114 11.8757C5.15114 11.6057 5.16366 11.3958 5.1887 11.246C5.21374 11.0962 5.25741 10.974 5.31973 10.8794C5.3865 10.7769 5.47497 10.6991 5.58514 10.6461C5.69531 10.5932 5.82329 10.5667 5.96907 10.5667ZM7.96804 10.5684C8.17057 10.5684 8.32692 10.6048 8.4371 10.6778C8.60535 10.7883 8.69461 10.9763 8.70486 11.2418L8.70584 11.2998H8.23345L8.23225 11.2473C8.22904 11.18 8.21943 11.124 8.2034 11.0794C8.16668 10.9768 8.08544 10.9256 7.95969 10.9256C7.874 10.9256 7.80751 10.9515 7.76022 11.0033C7.71292 11.0552 7.68927 11.1278 7.68927 11.2212C7.68927 11.3192 7.71264 11.395 7.75938 11.4485C7.80612 11.5021 7.89737 11.5562 8.03314 11.6109L8.18074 11.6713C8.29909 11.7207 8.38315 11.7587 8.43292 11.7852C8.50136 11.8216 8.55839 11.8632 8.60402 11.9099C8.71419 12.0227 8.76927 12.1885 8.76927 12.4072C8.76927 12.6613 8.70028 12.8516 8.56229 12.978C8.48995 13.0453 8.41039 13.0914 8.32359 13.1165C8.20897 13.1495 8.08043 13.166 7.93799 13.166C7.68538 13.166 7.49509 13.1074 7.36711 12.99C7.29923 12.9285 7.24971 12.8504 7.21855 12.7559C7.19184 12.6748 7.17658 12.5766 7.17276 12.4612L7.17181 12.4021V12.3508H7.65088L7.65143 12.3998C7.65399 12.5097 7.66549 12.5891 7.68594 12.638C7.73379 12.7519 7.82281 12.8089 7.95301 12.8089C8.05206 12.8089 8.12856 12.7798 8.18254 12.7217C8.23651 12.6636 8.26349 12.581 8.26349 12.4739C8.26349 12.3543 8.22455 12.262 8.14665 12.197C8.1166 12.172 8.08238 12.1509 8.04399 12.1338L7.77383 12.0219C7.74699 12.011 7.71825 11.9993 7.68761 11.9868C7.53404 11.9242 7.41886 11.8456 7.34207 11.751C7.2486 11.6382 7.20186 11.4884 7.20186 11.3015C7.20186 11.044 7.27697 10.8532 7.4272 10.729C7.55852 10.6219 7.7388 10.5684 7.96804 10.5684ZM9.63483 10.6179L9.90024 11.9527L9.91483 12.053C9.94743 12.2829 9.96994 12.4832 9.98234 12.6538L9.98704 12.7251H10.0004L10.0033 12.6719C10.0119 12.5297 10.0298 12.3544 10.0568 12.1461L10.0822 11.9595L10.3493 10.6179H10.8651L10.2992 13.1165H9.66988L9.10735 10.6179H9.63483ZM10.8488 8.58333V9.51667H5.15114V8.58333H10.8488ZM10.8488 6.13333V7.06667H5.15114V6.13333H10.8488ZM10.393 1L12.9 3.56667H10.393V1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ZIPIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.46998 1V4.5H12.9V15H3.09998V1H9.46998ZM8.71613 1.77778H3.85382V14.2222H12.1461V5.27778H8.71613V1.77778ZM10.8488 8.58333V9.51667H5.15114V8.58333H10.8488ZM6.71927 10.5004V10.9212L5.79295 12.6142L5.75078 12.69C5.72378 12.7367 5.699 12.776 5.67645 12.8077C5.72531 12.7989 5.82051 12.7946 5.96205 12.7946H6.73054V13.2474H5.0658V12.8434L5.99963 11.1223L6.05177 11.0302L6.10673 10.9457C6.06414 10.9507 6.00026 10.9532 5.91508 10.9532H5.13156V10.5004H6.71927ZM8.16209 10.5004V13.2474H7.6078V10.5004H8.16209ZM9.95252 10.5004L10.0638 10.5026C10.2768 10.5115 10.4333 10.5471 10.5331 10.6093C10.6484 10.682 10.7348 10.7885 10.7924 10.9288C10.8388 11.044 10.8619 11.1743 10.8619 11.3196C10.8619 11.5375 10.8118 11.7173 10.7116 11.8588C10.6014 12.0154 10.4223 12.1087 10.1742 12.1388C10.1154 12.1463 10.017 12.1501 9.87924 12.1501H9.68759V13.2474H9.1333V10.5004H9.95252ZM9.85106 10.9119H9.68759V11.7386H9.86421C9.99824 11.7386 10.0922 11.7198 10.1461 11.6822C10.2438 11.6158 10.2926 11.4949 10.2926 11.3196C10.2926 11.1442 10.2387 11.0246 10.131 10.9607C10.0784 10.9281 9.98509 10.9119 9.85106 10.9119ZM10.8488 6.13333V7.06667H5.15114V6.13333H10.8488ZM10.393 1L12.9 3.56667H10.393V1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const FileIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.46998 1V4.5H12.9V15H3.09998V1H9.46998ZM8.71613 1.77778H3.85382V14.2222H12.1461V5.27778H8.71613V1.77778ZM9.93719 11.0333V11.9667H5.15114V11.0333H9.93719ZM10.8488 8.58333V9.51667H5.15114V8.58333H10.8488ZM10.8488 6.13333V7.06667H5.15114V6.13333H10.8488ZM10.393 1L12.9 3.56667H10.393V1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const OfficeIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.46998 1V4.5H12.9V15H3.09998V1H9.46998ZM8.71613 1.77778H3.85382V14.2222H12.1461V5.27778H8.71613V1.77778ZM8.08544 10.3917V12.725H5.80637V10.3917H8.08544ZM10.8203 10.4208V12.3458H8.94009V10.4208H10.8203ZM7.51567 10.975H6.37614V12.1417H7.51567V10.975ZM10.2221 10.975H9.48137V11.7333H10.2221V10.975ZM8.08544 6.83333V9.60417H5.37905V6.83333H8.08544ZM10.5639 7.9125V9.60417H8.9116V7.9125H10.5639ZM7.51567 7.41667H5.94881V9.02083H7.51567V7.41667ZM9.99416 8.49583H9.48137V9.02083H9.99416V8.49583ZM10.393 1L12.9 3.56667H10.393V1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const VideoIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M11.535 4.14999V11.85H1V4.14999H11.535ZM15 5.07685V10.9231L12.48 9.46157V6.53842L15 5.07685Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const SoundIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M12.2 6.74V8.56C12.2 10.6341 10.581 12.4009 8.58315 12.6802L8.50805 12.69V13.95H10.879V15H5.12096V13.95H7.49192V12.725C5.48507 12.4485 3.84154 10.7044 3.80076 8.6723L3.79999 8.595V6.775H4.81612V8.595C4.81612 10.275 6.30644 11.71 7.99999 11.71C9.67034 11.71 11.143 10.28 11.183 8.6625L11.1839 8.595V6.74H12.2ZM7.99999 1C9.33332 1 10.437 2.11862 10.4717 3.48852L10.4726 3.555V8.455C10.4726 9.855 9.35483 11.01 7.99999 11.01C6.66665 11.01 5.56295 9.89138 5.52825 8.52148L5.52741 8.455V3.555C5.52741 2.155 6.64515 1 7.99999 1Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CopyIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.94445 6.05556H2.55556V13.4444H9.94445V6.05556ZM11.5 9.94445H13.4444V2.55556H6.05556V4.5H11.5V9.94445ZM11.5 15H1V4.5H4.5V1H15V11.5H11.5V15Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const MailIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M15 4.31668V12.55H1V4.31668L8 8.91203L15 4.31668ZM14.7812 3.45001L8 7.78335L1.21875 3.45001H14.7812Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const NotificationIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.48749 2.17884C11.6427 2.85334 12.3978 5.29153 12.3978 7C12.3978 8.33333 12.5703 9.66667 12.9152 11H13.95V12.5H2.04999V11H3.08477C3.4297 9.66667 3.60216 8.33333 3.60216 7C3.60216 5.29153 4.35726 2.85334 6.51249 2.17884V1H9.48749V2.17884ZM7.00832 1.5V2H8.99165V1.5H7.00832ZM7.99999 15C7.45231 15 7.00832 14.5523 7.00832 14C7.00832 13.4477 7.45231 13 7.99999 13C8.54767 13 8.99165 13.4477 8.99165 14C8.99165 14.5523 8.54767 15 7.99999 15Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const NotificationOutlineIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M6.7391 2.92197C5.24625 3.38917 4.3699 5.12478 4.3699 7C4.3699 8.40044 4.18887 9.80001 3.82743 11.1972L3.6916 11.7222H12.3084L12.1725 11.1972C11.8111 9.80001 11.6301 8.40044 11.6301 7C11.6301 5.12478 10.7537 3.38917 9.26088 2.92197C8.88853 2.80203 8.46823 2.74207 7.99999 2.74207C7.53174 2.74207 7.11144 2.80203 6.7391 2.92197ZM9.48749 1V2.17884C11.6427 2.85334 12.3978 5.29153 12.3978 7C12.3978 8.33333 12.5703 9.66667 12.9152 11H13.95V12.5H2.04999V11H3.08477C3.4297 9.66667 3.60216 8.33333 3.60216 7C3.60216 5.29153 4.35726 2.85334 6.51249 2.17884V1H9.48749ZM8.95967 1.58333H7.04031V2.16667H8.95967V1.58333ZM7.99999 14.2222C8.12445 14.2222 8.22391 14.1219 8.22391 14C8.22391 13.8781 8.12445 13.7778 7.99999 13.7778C7.87553 13.7778 7.77606 13.8781 7.77606 14C7.77606 14.1219 7.87553 14.2222 7.99999 14.2222ZM7.99999 15C7.45231 15 7.00832 14.5523 7.00832 14C7.00832 13.4477 7.45231 13 7.99999 13C8.54767 13 8.99165 13.4477 8.99165 14C8.99165 14.5523 8.54767 15 7.99999 15Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ImageIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M5.29272 6.57546C6.05202 6.57546 6.66829 5.95919 6.66829 5.19904C6.66829 4.43975 6.05202 3.82347 5.29272 3.82347C4.53258 3.82347 3.91715 4.43975 3.91715 5.19904C3.91715 5.95919 4.53258 6.57546 5.29272 6.57546ZM13.4448 7.28793L9.99128 10.3557L7.68272 7.37291L2.55502 11.4945V2.55509H13.4448V7.28793ZM13.4448 13.4448H2.61212L7.42231 9.57775L9.78013 12.6242L13.4445 9.36834L13.4448 13.4448ZM1 15H15V1H1V15Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const LocationIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8.0001 1C5.30155 1 3.1001 3.205 3.1001 5.97C3.1001 7.02 3.38416 7.825 4.02329 8.84C4.66242 9.82 8.0001 15 8.0001 15C8.0001 15 11.3378 9.82 11.9769 8.805C12.616 7.825 12.9001 6.985 12.9001 5.935C12.9001 3.205 10.6987 1 8.0001 1ZM8.0001 7.685C6.97039 7.685 6.11821 6.845 6.11821 5.83C6.11821 4.815 6.97039 3.975 8.0001 3.975C9.02981 3.975 9.88198 4.815 9.88198 5.83C9.88198 6.845 9.02981 7.685 8.0001 7.685Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const PlusIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8.99197 7.01007H15V8.98987H8.99235L8.98995 15L7.01005 14.9992L7.01245 8.98987H1V7.01007H7.01207L7.01005 1.00066L8.98995 1L8.99197 7.01007Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const MinusIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M15 6.95001V9.05001H1V6.95001H15Z" fill="currentColor" />
        </SvgIcon>
    );
};

export const UserCommentIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M7.66843 11.4186L9.32633 12.0698L9.65791 15H1.70001L2.03159 12.0698L3.68949 11.4186L5.67896 12.0698L7.66843 11.4186ZM5.67896 6.86047C6.87264 6.86047 7.5358 7.83721 7.46949 9.0093L7.46096 9.12088C7.37128 10.1243 6.92593 11.093 5.67896 11.093C4.3858 11.093 3.95475 10.0512 3.88843 9.0093C3.82212 7.86977 4.48528 6.86047 5.67896 6.86047ZM14.3 1V6.2093H10.4537L8.33159 8.29302V6.2093H7.00528V1H14.3ZM13.6369 1.65116H7.66843V5.55814H8.99475V6.73023L10.1884 5.55814H13.6369V1.65116Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CommentOutlinedIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M13.9577 1.70589V9.48273H10.0964V13.0235L7.25547 9.48273H2.04222V1.70589H13.9577ZM14.65 1H1.34998V10.1886H6.92735L10.788 15V10.1886H14.6493V1H14.65Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CommentIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path d="M15 11.4593H11.99V13.95L8 11.4593H1V2.08458L15 2.04999V11.4593Z" fill="currentColor" />
        </SvgIcon>
    );
};

export const DevicesIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M12.3082 2.39999L12.3081 3.57894H15V12.3965L10 12.3964V13.6H6.85714V11.1731L4.29821 11.1732L4.5338 10.4442H5.71173V9.71508H1V2.39999H12.3082ZM8.42856 12.9383C8.29713 12.9383 8.19047 13.0469 8.19047 13.1808C8.19047 13.3146 8.29713 13.4232 8.42856 13.4232C8.55999 13.4232 8.66665 13.3146 8.66665 13.1808C8.66665 13.0469 8.55999 12.9383 8.42856 12.9383ZM9.79724 7.8243H7.05991V12.7897H9.79724V7.8243ZM12.0498 11.3895C11.8646 11.3895 11.7143 11.5442 11.7143 11.7349C11.7143 11.9255 11.8646 12.0802 12.0498 12.0802C12.235 12.0802 12.3853 11.9255 12.3853 11.7349C12.3853 11.5442 12.235 11.3895 12.0498 11.3895ZM14.7143 4.02105H9.42857V7.41052H10V11.0947H14.7143V4.02105ZM11.6014 3.12907H1.70676V8.71868L6.85714 8.71856V7.41052H9.14286V3.57894H11.6013L11.6014 3.12907Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const FolderContractIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M13.0556 1.77777V6.05555H15L13.8333 14.2222H2.55556L1 7.22222H2.55556V1.77777H13.0556ZM14.1444 6.83333H13.0556V9.55555L13.4056 11.7333L14.1444 6.83333ZM12.2778 2.55555H3.33333V7.22222H4.5V4.88888H4.88889V7.22222H5.66667V3.72221H6.05556V7.22222H6.83333V4.49999H7.22222V7.22222H8V3.72221H8.38889V7.22222H9.16667V4.49999H9.55556V7.22222H12.2778V2.55555ZM11.4611 3.33332V4.49999C11.5 4.73333 11.3833 4.92777 11.3056 5.00555V5.04444C11.4222 5.1611 11.4611 5.27777 11.4222 5.43332C11.4222 5.62777 11.2278 5.78333 10.9944 5.86111C11.15 5.93888 11.3056 6.01666 11.3833 6.13333C11.4611 6.21111 11.5 6.32777 11.4611 6.44443C11.3833 6.67777 10.9944 6.79444 10.8778 6.83333L10.8 6.44443C10.9167 6.40555 11.0333 6.36666 10.9944 6.24999C10.8389 6.13333 10.3333 6.01666 9.90556 5.93888L9.94444 5.54999C10.4889 5.54999 10.9556 5.43332 10.9944 5.31666C11.0333 5.27777 10.9944 5.23888 10.9944 5.23888C10.9556 5.2 10.8389 5.1611 10.8 5.1611H10.7611L10.8 4.77222H10.8389C10.8778 4.77222 10.9556 4.77222 10.9944 4.73333C11.0333 4.69444 11.0722 4.53888 11.0722 4.49999V3.33332H11.4611Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const FolderStandIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M4.51598 2.8603V13.6H1V2.8603H4.51598ZM12.8265 2.40002L15 12.9556L11.5479 13.6L9.37443 3.07509L12.8265 2.40002ZM8.67123 2.8603V13.6H5.15525V2.89098L8.67123 2.8603ZM2.75799 11.1452C2.3105 11.1452 1.9589 11.4828 1.9589 11.9124C1.9589 12.3419 2.3105 12.6795 2.75799 12.6795C3.20548 12.6795 3.55708 12.3419 3.55708 11.9124C3.55708 11.4828 3.20548 11.1452 2.75799 11.1452ZM6.91324 11.1452C6.46575 11.1452 6.11416 11.4828 6.11416 11.9124C6.11416 12.3419 6.46575 12.6795 6.91324 12.6795C7.36073 12.6795 7.71233 12.3419 7.71233 11.9124C7.71233 11.4828 7.36073 11.1452 6.91324 11.1452ZM13.7215 11.4828C13.6575 11.0532 13.242 10.777 12.7945 10.8691C12.347 10.9304 12.0594 11.3293 12.1553 11.7589C12.2192 12.1885 12.6347 12.4647 13.0822 12.3726C13.5297 12.2806 13.7854 11.8817 13.7215 11.4828ZM3.87671 4.70139H1.63927V9.91783H3.87671V4.70139ZM8.03196 4.70139H5.79452V9.91783H8.03196V4.70139ZM12.5708 4.30249L10.3653 4.73208L11.4201 9.85646L13.6256 9.42687L12.5708 4.30249Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const FolderOpenIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 512 512" {...props}>
            <path
                fill="currentColor"
                d="M472,48H40.335a24.027,24.027,0,0,0-24,24V456a24.027,24.027,0,0,0,24,24H472a24.027,24.027,0,0,0,24-24V72A24.027,24.027,0,0,0,472,48Zm-8,32v71.981L48.335,151.49V80ZM48.335,448V183.49L464,183.981V448Z"
            />
        </SvgIcon>
    );
};

export const PackageCarryIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M5.3167 4.72334L5.3252 4.72157L6.7128 11.1213L14.6916 9.45871L15 10.8809L7.02115 12.5435C7.19145 13.3289 6.68001 14.101 5.87881 14.2679C5.07761 14.4349 4.29005 13.9335 4.11975 13.1481C3.94945 12.3626 4.4609 11.5905 5.2621 11.4236L3.95331 5.38735L1 2.78048L1.99239 1.7L5.32401 4.71628L5.3167 4.72334ZM6.05055 4.57042L11.8533 3.36126L13.0868 9.04992L7.28397 10.2591L6.05055 4.57042ZM10.452 5.51128L9.37423 7.33169L8.35419 6.81278L8.13906 7.2098L9.55183 7.92849L10.8514 5.73347L10.452 5.51128Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const WarningCircleIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 1.875C4.61726 1.875 1.875 4.61726 1.875 8C1.875 11.3827 4.61726 14.125 8 14.125C11.3827 14.125 14.125 11.3827 14.125 8C14.125 4.61726 11.3827 1.875 8 1.875ZM8.44014 10.625L8.87544 11.938H7.125L7.56152 10.625H8.44014ZM8.875 4.0625L8.43928 9.75H7.5625L7.125 4.0625H8.875Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const StopwatchOutlinedIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M7.99995 2.2C11.4793 2.2 14.3 5.06538 14.3 8.6C14.3 12.1346 11.4793 15 7.99995 15C4.52056 15 1.69995 12.1346 1.69995 8.6C1.69995 5.06538 4.52056 2.2 7.99995 2.2ZM7.99995 3C4.95548 3 2.48745 5.50721 2.48745 8.6C2.48745 11.6928 4.95548 14.2 7.99995 14.2C11.0444 14.2 13.5125 11.6928 13.5125 8.6C13.5125 5.50721 11.0444 3 7.99995 3ZM7.99995 3.8C10.6095 3.8 12.725 5.94864 12.725 8.59913H7.99995V3.8ZM12.9252 2.78697L14.2377 4.11382L13.5571 4.80182L12.2446 3.47497L12.9252 2.78697ZM10.3625 1V1.8H5.63745V1H10.3625Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ReloadIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M2.56441 9.11203C2.86648 10.4562 3.64476 11.6414 4.7571 12.452C5.98372 13.3646 7.54872 13.7102 9.06 13.4012C10.5718 13.0926 11.8876 12.1591 12.6788 10.8344C13.3993 9.6485 13.6688 8.24865 13.44 6.89146C13.139 5.55388 12.3662 4.37323 11.2617 3.56347C10.0388 2.63402 8.46695 2.28076 6.9499 2.59351C5.51968 2.90735 4.25834 3.75501 3.42739 4.96204L6.47288 4.67993L6.59524 6.16993L1.4235 6.64989L1 1.49931L2.49626 1.36045L2.66271 3.54456C3.69184 2.3166 5.10629 1.47009 6.67243 1.14415C8.5993 0.743574 10.5969 1.18694 12.1551 2.36095C13.56 3.3872 14.5352 4.89376 14.8974 6.59824C15.257 8.71246 14.6612 10.8882 13.2694 12.5448C12.1216 13.8877 10.5074 14.7492 8.75667 14.9532C7.00589 15.1574 5.25095 14.6885 3.84948 13.6423C2.44458 12.6161 1.46938 11.1095 1.10717 9.40502L2.56441 9.11203Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const SliderIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M15 2.39999V6.4405H13.53V13.6H12.48V6.4405H11.01V2.39999H15ZM8.525 2.39999V5.97974H9.995V10.0202H8.525V13.6H7.475V10.0202H6.005V5.97974H7.475V2.39999H8.525ZM3.52 2.39999V9.52404H4.99V13.5646H1V9.52404H2.47V2.39999H3.52Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};
export const ExportIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5-5 5z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};
export const ImportIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const PhoneIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M9.60554 14.7979C3.52023 11.853 1.95543 6.581 1.71237 4.62982C1.46923 2.712 4.87729 1 4.87729 1L7.03295 4.55998C7.03295 4.55998 4.73736 5.75828 5.05115 6.44302C6.72054 9.96979 8.9454 11.2362 8.9454 11.2362C9.64087 11.5104 11.241 9.76375 11.241 9.76375L14.3 12.607C14.3 12.607 11.7612 15.8248 9.60557 14.7977L9.60554 14.7979Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ClearIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 14 14" {...props}>
            <path
                d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7 0.777778C3.56356 0.777778 0.777778 3.56356 0.777778 7C0.777778 10.4364 3.56356 13.2222 7 13.2222C10.4364 13.2222 13.2222 10.4364 13.2222 7C13.2222 3.56356 10.4364 0.777778 7 0.777778ZM4.36713 3.5L7.0008 6.1319L9.63255 3.50015L10.4998 4.36742L7.86824 6.99901L10.5 9.63287L9.63238 10.4998L7.00096 7.86628L4.36727 10.5L3.5 9.6327L6.13352 6.99918L3.50015 4.36757L4.36713 3.5Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const CaretDownIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 12 7" {...props}>
            <path d="M0.75 0.875H11.25L6 6.125L0.75 0.875Z" fill="currentColor" />
        </SvgIcon>
    );
};

export const NewsLetterIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 32 36" {...props}>
            <path
                d="M26.8092 0L30.2102 3.40106V18H31.1576V36H0.841797V18H1.78917V0H26.8092ZM21.6839 23.6842H10.3155L15.9997 27.4737L21.6839 23.6842ZM25.4734 1.89474H3.6839V19.26L8.89443 22.7368H23.105L28.3155 19.26V4.73685H25.4734V1.89474ZM26.4207 18.9474V19.8947H12.2102V18.9474H26.4207ZM10.3155 15.1579V19.8947H5.57864V15.1579H10.3155ZM26.4207 15.1579V16.1053H12.2102V15.1579H26.4207ZM25.9281 6.44211C26.1174 6.73556 26.2162 7.07819 26.2123 7.42738H25.265C25.2495 7.14177 25.1141 6.87597 24.8922 6.69553C24.6703 6.51509 24.3824 6.43682 24.0997 6.48C23.8596 6.46645 23.6205 6.51887 23.4081 6.63159C23.1837 6.74876 23.0472 6.98496 23.0576 7.2379C23.0428 7.43236 23.1378 7.61878 23.3039 7.72105C23.6681 7.87013 24.0455 7.98432 24.4313 8.06211C24.7035 8.11971 24.9724 8.19246 25.2365 8.28C25.4109 8.33591 25.5766 8.41561 25.7292 8.51684C26.1557 8.74459 26.4217 9.18913 26.4207 9.67264C26.4413 10.1557 26.2257 10.6185 25.8429 10.9137C25.3851 11.2388 24.8308 11.399 24.2702 11.3684C23.6822 11.3961 23.1029 11.2186 22.6313 10.8663C22.2245 10.508 21.9988 9.98703 22.0155 9.44526H22.9629C22.9549 9.71876 23.042 9.98658 23.2092 10.2032C23.517 10.5011 23.9378 10.6529 24.365 10.62C24.6635 10.6408 24.9605 10.5608 25.2081 10.3926C25.3943 10.2366 25.4932 9.99998 25.4734 9.7579C25.4768 9.63295 25.4403 9.51014 25.3692 9.40737C25.2774 9.29387 25.1607 9.20308 25.0281 9.1421C24.7602 9.03878 24.4846 8.95642 24.2039 8.89579C23.6914 8.79373 23.1946 8.62492 22.726 8.39368C22.3581 8.15679 22.1449 7.74125 22.1671 7.30421C22.1503 6.85228 22.3554 6.42069 22.7165 6.14843C23.1408 5.82761 23.663 5.66357 24.1944 5.68421C24.8661 5.60956 25.5267 5.89835 25.9281 6.44211ZM5.74917 5.83579L7.52074 8.6779C7.88075 9.24633 8.14601 9.70105 8.31653 10.0421V5.83579H9.29232V11.2547H8.34496L6.52601 8.52631C6.22112 8.07076 5.94582 7.59611 5.70179 7.10526C5.70179 7.51263 5.74917 8.05264 5.74917 8.76316V11.2926H4.8018V5.83579H5.74917ZM15.5923 5.79789L16.265 8.59263C16.3881 9.0758 16.4923 9.60632 16.5871 10.2032C16.6913 9.59684 16.805 9.05685 16.9281 8.59263L17.6765 5.79789H18.6239L19.3818 8.64001C19.4671 8.96211 19.5713 9.49263 19.7134 10.241C19.8176 9.61579 19.9218 9.08527 20.0355 8.63052L20.7365 5.83579H21.6839L20.2155 11.2547H19.2681L18.5102 8.41263C18.4534 8.19157 18.3397 7.67052 18.1692 6.84948C18.0555 7.39894 17.9418 7.91052 17.8186 8.37474L17.0702 11.2168H16.0755L14.645 5.79789H15.5923ZM14.285 5.83579V6.63159H11.3386V8.05264H14.105V8.82947H11.3386V10.4211H14.3323V11.2358H10.3818V5.83579H14.285Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const FileDownloadIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 26 36" {...props}>
            <path
                d="M16.7804 0V9H25.6004V36H0.400391V0H16.7804ZM13.974 15H11.8863V26.6369L9.43134 24.2065L8.019 25.8635L12.9608 30.75L17.9025 25.8635L16.4902 24.2065L13.974 26.6975V15ZM19.1539 0L25.6004 6.6H19.1539V0Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const AIChatIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                d="M8.48 4h4l.5.5v2.03h.52l.5.5V8l-.5.5h-.52v3l-.5.5H9.36l-2.5 2.76L6 14.4V12H3.5l-.5-.64V8.5h-.5L2 8v-.97l.5-.5H3V4.36L3.53 4h4V2.86A1 1 0 0 1 7 2a1 1 0 0 1 2 0 1 1 0 0 1-.52.83V4zM12 8V5H4v5.86l2.5.14H7v2.19l1.8-2.04.35-.15H12V8zm-2.12.51a2.71 2.71 0 0 1-1.37.74v-.01a2.71 2.71 0 0 1-2.42-.74l-.7.71c.34.34.745.608 1.19.79.45.188.932.286 1.42.29a3.7 3.7 0 0 0 2.58-1.07l-.7-.71zM6.49 6.5h-1v1h1v-1zm3 0h1v1h-1v-1z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const SendMessageIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M20.33 3.66996C20.1408 3.48213 19.9035 3.35008 19.6442 3.28833C19.3849 3.22659 19.1135 3.23753 18.86 3.31996L4.23 8.19996C3.95867 8.28593 3.71891 8.45039 3.54099 8.67255C3.36307 8.89471 3.25498 9.16462 3.23037 9.44818C3.20576 9.73174 3.26573 10.0162 3.40271 10.2657C3.5397 10.5152 3.74754 10.7185 4 10.85L10.07 13.85L13.07 19.94C13.1906 20.1783 13.3751 20.3785 13.6029 20.518C13.8307 20.6575 14.0929 20.7309 14.36 20.73H14.46C14.7461 20.7089 15.0192 20.6023 15.2439 20.4239C15.4686 20.2456 15.6345 20.0038 15.72 19.73L20.67 5.13996C20.7584 4.88789 20.7734 4.6159 20.7132 4.35565C20.653 4.09541 20.5201 3.85762 20.33 3.66996ZM4.85 9.57996L17.62 5.31996L10.53 12.41L4.85 9.57996ZM14.43 19.15L11.59 13.47L18.68 6.37996L14.43 19.15Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export const ViewModuleIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path d="M4 10.5h5v-5H4v5zm0 7h5v-5H4v5zm6.5 0h5v-5h-5v5zm6.5 0h5v-5h-5v5zM10.5 10.5h5v-5h-5v5zm6.5 0h5v-5h-5v5z" fill="currentColor"/>
        </SvgIcon>
    );
}

export const ViewListIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path d="M4 14h2v-2H4v2zm0 4h2v-2H4v2zm0-8h2V8H4v2zm4 8h12v-2H8v2zm0-4h12v-2H8v2zm0-6v2h12V8H8z" fill="currentColor"/>
        </SvgIcon>
    );
};
